import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
    Category,
    Color,
    Order,
    Product,
    ProductResponse,
    ProductSlider,
    ProductSliderResponse,
    Size
} from './app.models';
import { environment } from 'src/environments/environment';
import {ApiUrl} from "./shared/models/apiurl.models";
import {any} from "codelyzer/util/function";

export class Data {
    constructor(public categories: Category[],
                public compareList: Product[],
                public wishList: Product[],
                public cartList: Product[],
                public selectedColorList: {},
                public totalPrice: number,
                public totalCartCount: number) { }
}

@Injectable()
export class AppService {
    public Data = new Data(
        [], // categories
        [], // compareList
        [],  // wishList
        [],  // cartList
        {}, //selectedColorList,
        null, //totalPrice,
        0 //totalCartCount
    )
    _isClicked: string = 'chooseProduct';
    private options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Accept":"application/json",

            "Referer":"http://localhost:4200/",


        }),

    }
    public _selectedProduct: Array<ProductSlider> = [];
    public showProducts = false;

    public setShowProductSlider($event= null){
        this.showProducts = this.showProducts ? false: true
    }
    removeProduct(productSlider: ProductSlider){
        const index = this.selectedProduct.indexOf(productSlider)
        if(this.selectedProduct.indexOf(productSlider) != -1){
            if(this._selectedProduct[index].quantity>1){
                this._selectedProduct[index].quantity--;
            }else{
             this._selectedProduct.splice(index,1);
            }
        }
        this.layoutProducts();
    }
    selectProduct(productSlider: ProductSlider){
        const index = this.selectedProduct.indexOf(productSlider)
        if(this._selectedProduct.length==6 && this._isClicked == 'chooseProduct' && index == -1){
            alert("הגעת ל מכסה של מוצרים נבחרים")
            return;
        }
        if(this.selectedProduct.indexOf(productSlider)==-1){
            if(this._isClicked == 'completeProduct'){
                productSlider.quantity = 1;
            }else{
                productSlider.quantity = 6;
            }

            productSlider.category = this._isClicked
            this._selectedProduct.push(productSlider)
        }else {
            this._selectedProduct[index].quantity++;
        }
        this.layoutProducts();
    }
    shuffleProducts(): void {
        for (let i = this.selectedProduct.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [this.selectedProduct[i], this.selectedProduct[j]] = [this.selectedProduct[j], this.selectedProduct[i]];
        }
    }
    generateRandomPositions(): void {
        for (let i = 0; i < this.selectedProduct.length; i++) {
            const x = Math.random() * 200 + 'px';
            const y = Math.random() * 200 + 'px';
            this.positions.push({ x, y });
        }
    }

    rows: any[][] = [];

    layoutProducts(): void {
        this.rows = []
        let currentRowLength = 6;
        for (let i = 0; i < this.selectedProduct.length; i += currentRowLength) {
            const currentRow = this.selectedProduct.slice(i, i + currentRowLength-1);
            this.rows.push(currentRow);

            currentRowLength = Math.max(currentRowLength - 1, 1);
        }

    }

    positions: { x: string, y: string }[] = [];

    get selectedProduct(){
        return this._selectedProduct;
    }

    getSelectedProductByCategory(chooseProduct:any){
        let products =this._selectedProduct.filter(prd=>prd.category == chooseProduct);
        return  products
    }


    public url = environment.url + '/assets/data/'; 

    constructor(private apiUrl: ApiUrl,public http:HttpClient, public snackBar: MatSnackBar) { }

    public submitOrder(order): Observable<Order[]>{
        return this.http.post<Order[]>(this.apiUrl.getOrder(), JSON.stringify(order), this.options)
    }

    public getCategories(): Observable<Category[]>{
        return this.http.get<Category[]>(this.apiUrl.getCategories());
    }

    public getColor(): Observable<Color[]>{
        return this.http.get<Color[]>(this.apiUrl.getColor());
    }

    public getSize(): Observable<Size[]>{
        return this.http.get<Size[]>(this.apiUrl.getSize());
    }
    productList:any = [
        {name: "Product 2", image: "assets/imgaes/2.png", min_price:38, max_price:40},
        {name: "Product 3", image: "assets/imgaes/3.png", min_price:38, max_price:40},
        {name: "Product 4", image: "assets/imgaes/4.png", min_price:38, max_price:40},
        {name: "Product 5", image: "assets/imgaes/5.png", min_price:38, max_price:40},
        {name: "Product 6", image: "assets/imgaes/6.png", min_price:38, max_price:40},
        {name: "Product 7", image: "assets/imgaes/7.png", min_price:38, max_price:40},
        {name: "Product 8", image: "assets/imgaes/8.png", min_price:38, max_price:40},
        {name: "Product 9", image: "assets/imgaes/9.png", min_price:38, max_price:40},
        {name: "Product 10", image: "assets/imgaes/10.png", min_price:38, max_price:40},
        {name: "Product 11", image: "assets/imgaes/11.png", min_price:38, max_price:40},
        {name: "Product 12", image: "assets/imgaes/12.png", min_price:38, max_price:40},
        {name: "Product 13", image: "assets/imgaes/13.png", min_price:38, max_price:40},
        {name: "Product 14", image: "assets/imgaes/14.png", min_price:38, max_price:40},
        {name: "Product 15", image: "assets/imgaes/15.png", min_price:38, max_price:40},
        {name: "Product 16", image: "assets/imgaes/16.png", min_price:38, max_price:40},
        {name: "Product 17", image: "assets/imgaes/17.png", min_price:38, max_price:40},
        {name: "Product 18", image: "assets/imgaes/18.png", min_price:38, max_price:40},
        {name: "Product 19", image: "assets/imgaes/19.png", min_price:38, max_price:40},
        {name: "Product 20", image: "assets/imgaes/20.png", min_price:38, max_price:40},
        {name: "Product 21", image: "assets/imgaes/21.png", min_price:38, max_price:40},
        {name: "Product 22", image: "assets/imgaes/21.png", min_price:38, max_price:40},
        {name: "Product 23", image: "assets/imgaes/21.png", min_price:38, max_price:40},

    ]


    public getSliderProducts(type:string, offset: number=null, limit: number=null): Observable<any>{
        // const url = (offset != null && limit != null)?'?offset='+ offset +'&limit='+ limit:'';
        return this.http.get<any>( 'https://api.nutri-center.co.il/api/product/', this.options);
        // return of(this.productList);
    }
    public getProducts(type:string, offset: number=null, limit: number=null): Observable<ProductResponse>{
        const url = (offset != null && limit != null)?'?offset='+ offset +'&limit='+ limit:'';
        return this.http.get<ProductResponse>(this.apiUrl.getProducts() + url, this.options);
        // return of(this.productList);
    }

    public searchProducts( offset: number=null, limit: number=null, searchInput = ''): Observable<ProductResponse>{
        let url = (offset != null && limit != null)?'?offset='+ offset +'&limit='+ limit:'';
        url = searchInput ? url + "&q=" + searchInput : '';
        return this.http.get<ProductResponse>(this.apiUrl.getSearchProductsUrl() + url, this.options);
    }
    
    public deleteProduct(id: number): Observable<any>{
        return this.http.delete(this.apiUrl.getProducts() + id + "/", this.options);
    }
    
    public getProductById(id): Observable<Product>{
        return this.http.get<Product>(this.apiUrl.getProduct(id), this.options);
    }

    public getBanners(): Observable<any[]>{
        return this.http.get<any[]>(this.apiUrl.getBanners());
    }

    public addToCompare(product:Product){
        let message, status;
        if(this.Data.compareList.filter(item=>item.id == product.id)[0]){
            message = ' המוצר ' + product.name + ' כבר נמצא ברשימת ההשוואה ';
            status = 'error';     
        }
        else{
            this.Data.compareList.push(product);
            message = ' המוצר ' + product.name + ' הוסף לרשימת ההשוואה ';
            status = 'success';  
        }
        this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 });
    }

    public addToWishList(product:Product){
        let message, status;
        if(this.Data.wishList.filter(item=>item.id == product.id)[0]){
            message =  ' המוצר ' + product.name +  ' כבר נמצא ברשימת המועדפים ';
            status = 'error';     
        }
        else{
            this.Data.wishList.push(product);
            message = ' המוצר ' + product.name +  ' הוסף לרשימת המועדפים ' ;
            status = 'success';  
        }
        this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 });
    }

    public updateProductColor(product: any, opt){
        if(product.selectedColor == null) return;
        const sColor = product.selectedColor[0]
        if(sColor == null) return;
        const colorObj ={id:sColor?.id, name: sColor.name, image: sColor.image, code: sColor.code, count:1}
        if(opt =="+"){
            if(this.Data.selectedColorList[product.id] == null || this.Data.selectedColorList[product.id].length == 0){
                this.Data.selectedColorList[product.id] = [colorObj]
            }else{
                const existColor = this.Data.selectedColorList[product.id].find(selectedColor => selectedColor.id == sColor.id)
                if(existColor){
                    const colorIndex = this.Data.selectedColorList[product.id].indexOf(existColor);
                    this.Data.selectedColorList[product.id][colorIndex].count++
                }else {
                    this.Data.selectedColorList[product.id].push(colorObj)
                }
            }
        }
        if(opt == "-"){
            if(this.Data.selectedColorList[product.id] == null) return;
            const existColor = this.Data.selectedColorList[product.id].find(selectedColor => selectedColor.id == sColor.id)
            if(existColor == null) return;
            const colorIndex = this.Data.selectedColorList[product.id].indexOf(existColor);
            if(existColor.count == 1){
                this.Data.selectedColorList[product.id].splice(colorIndex, 1);
            }else{
                this.Data.selectedColorList[product.id][colorIndex].count--
            }
        }
    }

    public addToCart(product:Product){
        let message, status;        

        if((product.selectedColor == null || product.selectedColor.length==0) && product.color.length > 0){
            product.selectedColor=[product.color[0]]
        }

        this.Data.totalPrice = null;
        this.Data.totalCartCount = null;

        if(this.Data.cartList.filter(item=>item.id == product.id)[0]){ 
            let item = this.Data.cartList.filter(item=>item.id == product.id)[0];
            item.cartCount = product.cartCount;  
        }
        else{           
            this.Data.cartList.push(product);
        }

        this.updateProductColor(product, "+");

        this.Data.cartList.forEach(product=>{
            this.Data.totalPrice = this.Data.totalPrice + (product.cartCount * product.clientPrice);
            this.Data.totalCartCount = this.Data.totalCartCount + product.cartCount;
        });

        message = ' המוצר ' + product.name + ' הוסף להזמנה  ';
        status = 'success';          
        this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 });
    }

    public resetProductCartCount(product:Product){
        product.cartCount = 0;
        let compareProduct = this.Data.compareList.filter(item=>item.id == product.id)[0];
        if(compareProduct){
            compareProduct.cartCount = 0;
        };
        let wishProduct = this.Data.wishList.filter(item=>item.id == product.id)[0];
        if(wishProduct){
            wishProduct.cartCount = 0;
        }; 
    }

    public getBrands(){
        return [  
            { name: 'aloha', image: 'assets/images/brands/aloha.png' },
            { name: 'dream', image: 'assets/images/brands/dream.png' },  
            { name: 'congrats', image: 'assets/images/brands/congrats.png' },
            { name: 'best', image: 'assets/images/brands/best.png' },
            { name: 'original', image: 'assets/images/brands/original.png' },
            { name: 'retro', image: 'assets/images/brands/retro.png' },
            { name: 'king', image: 'assets/images/brands/king.png' },
            { name: 'love', image: 'assets/images/brands/love.png' },
            { name: 'the', image: 'assets/images/brands/the.png' },
            { name: 'easter', image: 'assets/images/brands/easter.png' },
            { name: 'with', image: 'assets/images/brands/with.png' },
            { name: 'special', image: 'assets/images/brands/special.png' },
            { name: 'bravo', image: 'assets/images/brands/bravo.png' }
        ];
    }

    public getCountries(){
        return [ 
            {name: 'Afghanistan', code: 'AF'}, 
            {name: 'Aland Islands', code: 'AX'}, 
            {name: 'Albania', code: 'AL'}, 
            {name: 'Algeria', code: 'DZ'}, 
            {name: 'American Samoa', code: 'AS'}, 
            {name: 'AndorrA', code: 'AD'}, 
            {name: 'Angola', code: 'AO'}, 
            {name: 'Anguilla', code: 'AI'}, 
            {name: 'Antarctica', code: 'AQ'}, 
            {name: 'Antigua and Barbuda', code: 'AG'}, 
            {name: 'Argentina', code: 'AR'}, 
            {name: 'Armenia', code: 'AM'}, 
            {name: 'Aruba', code: 'AW'}, 
            {name: 'Australia', code: 'AU'}, 
            {name: 'Austria', code: 'AT'}, 
            {name: 'Azerbaijan', code: 'AZ'}, 
            {name: 'Bahamas', code: 'BS'}, 
            {name: 'Bahrain', code: 'BH'}, 
            {name: 'Bangladesh', code: 'BD'}, 
            {name: 'Barbados', code: 'BB'}, 
            {name: 'Belarus', code: 'BY'}, 
            {name: 'Belgium', code: 'BE'}, 
            {name: 'Belize', code: 'BZ'}, 
            {name: 'Benin', code: 'BJ'}, 
            {name: 'Bermuda', code: 'BM'}, 
            {name: 'Bhutan', code: 'BT'}, 
            {name: 'Bolivia', code: 'BO'}, 
            {name: 'Bosnia and Herzegovina', code: 'BA'}, 
            {name: 'Botswana', code: 'BW'}, 
            {name: 'Bouvet Island', code: 'BV'}, 
            {name: 'Brazil', code: 'BR'}, 
            {name: 'British Indian Ocean Territory', code: 'IO'}, 
            {name: 'Brunei Darussalam', code: 'BN'}, 
            {name: 'Bulgaria', code: 'BG'}, 
            {name: 'Burkina Faso', code: 'BF'}, 
            {name: 'Burundi', code: 'BI'}, 
            {name: 'Cambodia', code: 'KH'}, 
            {name: 'Cameroon', code: 'CM'}, 
            {name: 'Canada', code: 'CA'}, 
            {name: 'Cape Verde', code: 'CV'}, 
            {name: 'Cayman Islands', code: 'KY'}, 
            {name: 'Central African Republic', code: 'CF'}, 
            {name: 'Chad', code: 'TD'}, 
            {name: 'Chile', code: 'CL'}, 
            {name: 'China', code: 'CN'}, 
            {name: 'Christmas Island', code: 'CX'}, 
            {name: 'Cocos (Keeling) Islands', code: 'CC'}, 
            {name: 'Colombia', code: 'CO'}, 
            {name: 'Comoros', code: 'KM'}, 
            {name: 'Congo', code: 'CG'}, 
            {name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
            {name: 'Cook Islands', code: 'CK'}, 
            {name: 'Costa Rica', code: 'CR'}, 
            {name: 'Cote D\'Ivoire', code: 'CI'}, 
            {name: 'Croatia', code: 'HR'}, 
            {name: 'Cuba', code: 'CU'}, 
            {name: 'Cyprus', code: 'CY'}, 
            {name: 'Czech Republic', code: 'CZ'}, 
            {name: 'Denmark', code: 'DK'}, 
            {name: 'Djibouti', code: 'DJ'}, 
            {name: 'Dominica', code: 'DM'}, 
            {name: 'Dominican Republic', code: 'DO'}, 
            {name: 'Ecuador', code: 'EC'}, 
            {name: 'Egypt', code: 'EG'}, 
            {name: 'El Salvador', code: 'SV'}, 
            {name: 'Equatorial Guinea', code: 'GQ'}, 
            {name: 'Eritrea', code: 'ER'}, 
            {name: 'Estonia', code: 'EE'}, 
            {name: 'Ethiopia', code: 'ET'}, 
            {name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
            {name: 'Faroe Islands', code: 'FO'}, 
            {name: 'Fiji', code: 'FJ'}, 
            {name: 'Finland', code: 'FI'}, 
            {name: 'France', code: 'FR'}, 
            {name: 'French Guiana', code: 'GF'}, 
            {name: 'French Polynesia', code: 'PF'}, 
            {name: 'French Southern Territories', code: 'TF'}, 
            {name: 'Gabon', code: 'GA'}, 
            {name: 'Gambia', code: 'GM'}, 
            {name: 'Georgia', code: 'GE'}, 
            {name: 'Germany', code: 'DE'}, 
            {name: 'Ghana', code: 'GH'}, 
            {name: 'Gibraltar', code: 'GI'}, 
            {name: 'Greece', code: 'GR'}, 
            {name: 'Greenland', code: 'GL'}, 
            {name: 'Grenada', code: 'GD'}, 
            {name: 'Guadeloupe', code: 'GP'}, 
            {name: 'Guam', code: 'GU'}, 
            {name: 'Guatemala', code: 'GT'}, 
            {name: 'Guernsey', code: 'GG'}, 
            {name: 'Guinea', code: 'GN'}, 
            {name: 'Guinea-Bissau', code: 'GW'}, 
            {name: 'Guyana', code: 'GY'}, 
            {name: 'Haiti', code: 'HT'}, 
            {name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
            {name: 'Holy See (Vatican City State)', code: 'VA'}, 
            {name: 'Honduras', code: 'HN'}, 
            {name: 'Hong Kong', code: 'HK'}, 
            {name: 'Hungary', code: 'HU'}, 
            {name: 'Iceland', code: 'IS'}, 
            {name: 'India', code: 'IN'}, 
            {name: 'Indonesia', code: 'ID'}, 
            {name: 'Iran, Islamic Republic Of', code: 'IR'}, 
            {name: 'Iraq', code: 'IQ'}, 
            {name: 'Ireland', code: 'IE'}, 
            {name: 'Isle of Man', code: 'IM'}, 
            {name: 'Israel', code: 'IL'}, 
            {name: 'Italy', code: 'IT'}, 
            {name: 'Jamaica', code: 'JM'}, 
            {name: 'Japan', code: 'JP'}, 
            {name: 'Jersey', code: 'JE'}, 
            {name: 'Jordan', code: 'JO'}, 
            {name: 'Kazakhstan', code: 'KZ'}, 
            {name: 'Kenya', code: 'KE'}, 
            {name: 'Kiribati', code: 'KI'}, 
            {name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
            {name: 'Korea, Republic of', code: 'KR'}, 
            {name: 'Kuwait', code: 'KW'}, 
            {name: 'Kyrgyzstan', code: 'KG'}, 
            {name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
            {name: 'Latvia', code: 'LV'}, 
            {name: 'Lebanon', code: 'LB'}, 
            {name: 'Lesotho', code: 'LS'}, 
            {name: 'Liberia', code: 'LR'}, 
            {name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
            {name: 'Liechtenstein', code: 'LI'}, 
            {name: 'Lithuania', code: 'LT'}, 
            {name: 'Luxembourg', code: 'LU'}, 
            {name: 'Macao', code: 'MO'}, 
            {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
            {name: 'Madagascar', code: 'MG'}, 
            {name: 'Malawi', code: 'MW'}, 
            {name: 'Malaysia', code: 'MY'}, 
            {name: 'Maldives', code: 'MV'}, 
            {name: 'Mali', code: 'ML'}, 
            {name: 'Malta', code: 'MT'}, 
            {name: 'Marshall Islands', code: 'MH'}, 
            {name: 'Martinique', code: 'MQ'}, 
            {name: 'Mauritania', code: 'MR'}, 
            {name: 'Mauritius', code: 'MU'}, 
            {name: 'Mayotte', code: 'YT'}, 
            {name: 'Mexico', code: 'MX'}, 
            {name: 'Micronesia, Federated States of', code: 'FM'}, 
            {name: 'Moldova, Republic of', code: 'MD'}, 
            {name: 'Monaco', code: 'MC'}, 
            {name: 'Mongolia', code: 'MN'}, 
            {name: 'Montserrat', code: 'MS'}, 
            {name: 'Morocco', code: 'MA'}, 
            {name: 'Mozambique', code: 'MZ'}, 
            {name: 'Myanmar', code: 'MM'}, 
            {name: 'Namibia', code: 'NA'}, 
            {name: 'Nauru', code: 'NR'}, 
            {name: 'Nepal', code: 'NP'}, 
            {name: 'Netherlands', code: 'NL'}, 
            {name: 'Netherlands Antilles', code: 'AN'}, 
            {name: 'New Caledonia', code: 'NC'}, 
            {name: 'New Zealand', code: 'NZ'}, 
            {name: 'Nicaragua', code: 'NI'}, 
            {name: 'Niger', code: 'NE'}, 
            {name: 'Nigeria', code: 'NG'}, 
            {name: 'Niue', code: 'NU'}, 
            {name: 'Norfolk Island', code: 'NF'}, 
            {name: 'Northern Mariana Islands', code: 'MP'}, 
            {name: 'Norway', code: 'NO'}, 
            {name: 'Oman', code: 'OM'}, 
            {name: 'Pakistan', code: 'PK'}, 
            {name: 'Palau', code: 'PW'}, 
            {name: 'Palestinian Territory, Occupied', code: 'PS'}, 
            {name: 'Panama', code: 'PA'}, 
            {name: 'Papua New Guinea', code: 'PG'}, 
            {name: 'Paraguay', code: 'PY'}, 
            {name: 'Peru', code: 'PE'}, 
            {name: 'Philippines', code: 'PH'}, 
            {name: 'Pitcairn', code: 'PN'}, 
            {name: 'Poland', code: 'PL'}, 
            {name: 'Portugal', code: 'PT'}, 
            {name: 'Puerto Rico', code: 'PR'}, 
            {name: 'Qatar', code: 'QA'}, 
            {name: 'Reunion', code: 'RE'}, 
            {name: 'Romania', code: 'RO'}, 
            {name: 'Russian Federation', code: 'RU'}, 
            {name: 'RWANDA', code: 'RW'}, 
            {name: 'Saint Helena', code: 'SH'}, 
            {name: 'Saint Kitts and Nevis', code: 'KN'}, 
            {name: 'Saint Lucia', code: 'LC'}, 
            {name: 'Saint Pierre and Miquelon', code: 'PM'}, 
            {name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
            {name: 'Samoa', code: 'WS'}, 
            {name: 'San Marino', code: 'SM'}, 
            {name: 'Sao Tome and Principe', code: 'ST'}, 
            {name: 'Saudi Arabia', code: 'SA'}, 
            {name: 'Senegal', code: 'SN'}, 
            {name: 'Serbia and Montenegro', code: 'CS'}, 
            {name: 'Seychelles', code: 'SC'}, 
            {name: 'Sierra Leone', code: 'SL'}, 
            {name: 'Singapore', code: 'SG'}, 
            {name: 'Slovakia', code: 'SK'}, 
            {name: 'Slovenia', code: 'SI'}, 
            {name: 'Solomon Islands', code: 'SB'}, 
            {name: 'Somalia', code: 'SO'}, 
            {name: 'South Africa', code: 'ZA'}, 
            {name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
            {name: 'Spain', code: 'ES'}, 
            {name: 'Sri Lanka', code: 'LK'}, 
            {name: 'Sudan', code: 'SD'}, 
            {name: 'Suriname', code: 'SR'}, 
            {name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
            {name: 'Swaziland', code: 'SZ'}, 
            {name: 'Sweden', code: 'SE'}, 
            {name: 'Switzerland', code: 'CH'}, 
            {name: 'Syrian Arab Republic', code: 'SY'}, 
            {name: 'Taiwan, Province of China', code: 'TW'}, 
            {name: 'Tajikistan', code: 'TJ'}, 
            {name: 'Tanzania, United Republic of', code: 'TZ'}, 
            {name: 'Thailand', code: 'TH'}, 
            {name: 'Timor-Leste', code: 'TL'}, 
            {name: 'Togo', code: 'TG'}, 
            {name: 'Tokelau', code: 'TK'}, 
            {name: 'Tonga', code: 'TO'}, 
            {name: 'Trinidad and Tobago', code: 'TT'}, 
            {name: 'Tunisia', code: 'TN'}, 
            {name: 'Turkey', code: 'TR'}, 
            {name: 'Turkmenistan', code: 'TM'}, 
            {name: 'Turks and Caicos Islands', code: 'TC'}, 
            {name: 'Tuvalu', code: 'TV'}, 
            {name: 'Uganda', code: 'UG'}, 
            {name: 'Ukraine', code: 'UA'}, 
            {name: 'United Arab Emirates', code: 'AE'}, 
            {name: 'United Kingdom', code: 'GB'}, 
            {name: 'United States', code: 'US'}, 
            {name: 'United States Minor Outlying Islands', code: 'UM'}, 
            {name: 'Uruguay', code: 'UY'}, 
            {name: 'Uzbekistan', code: 'UZ'}, 
            {name: 'Vanuatu', code: 'VU'}, 
            {name: 'Venezuela', code: 'VE'}, 
            {name: 'Viet Nam', code: 'VN'}, 
            {name: 'Virgin Islands, British', code: 'VG'}, 
            {name: 'Virgin Islands, U.S.', code: 'VI'}, 
            {name: 'Wallis and Futuna', code: 'WF'}, 
            {name: 'Western Sahara', code: 'EH'}, 
            {name: 'Yemen', code: 'YE'}, 
            {name: 'Zambia', code: 'ZM'}, 
            {name: 'Zimbabwe', code: 'ZW'} 
        ]
    }

    public getMonths(){
        return [
            { value: '01', name: 'January' },
            { value: '02', name: 'February' },
            { value: '03', name: 'March' },
            { value: '04', name: 'April' },
            { value: '05', name: 'May' },
            { value: '06', name: 'June' },
            { value: '07', name: 'July' },
            { value: '08', name: 'August' },
            { value: '09', name: 'September' },
            { value: '10', name: 'October' },
            { value: '11', name: 'November' },
            { value: '12', name: 'December' }
        ]
    }

    public getYears(){
        return ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030" ]
    }

    public getDeliveryMethods(){
        return [
            { value: 'free', name: 'Free Delivery', desc: '$0.00 / Delivery in 7 to 14 business Days' },
            { value: 'standard', name: 'Standard Delivery', desc: '$7.99 / Delivery in 5 to 7 business Days' },
            { value: 'express', name: 'Express Delivery', desc: '$29.99 / Delivery in 1 business Days' }
        ]
    }

} 
